<template>
  <div v-if="institution" class="card payment-services-card">
    <div class="card-header">
      <h4 class="title">Payment Services</h4>
    </div>
    <div class="card-body">
      <p>
        Payment services for <strong>{{ submerchantName }}</strong> are provided
        by <strong>{{ institution.name }}</strong
        >, {{ licenceTypeWithArticle }} {{ institution.regulatoryStatus }}.
      </p>

      <table class="table">
        <tbody>
          <tr>
            <th>Institution</th>
            <td>{{ institution.name }}</td>
          </tr>
          <tr>
            <th>Company number</th>
            <td>{{ institution.companyNumber }}</td>
          </tr>
          <tr>
            <th>Regulator</th>
            <td>{{ institution.regulator }}</td>
          </tr>
          <tr>
            <th>Register entry</th>
            <td>
              <a
                :href="institution.url"
                target="_blank"
                rel="noopener noreferrer"
                >View on {{ institution.registerName }}
                <i class="fa fa-external-link ml-1"></i
              ></a>
            </td>
          </tr>
        </tbody>
      </table>

      <p class="text-muted small mb-0">
        If you have a question about these payment services, please
        <router-link to="/support">contact support</router-link>.
      </p>
    </div>
  </div>
</template>
<script>
import {
  getFinancialInstitution,
  withIndefiniteArticle,
} from "src/financialInstitutions";

export default {
  name: "payment-services-card",
  props: {
    submerchant: {
      type: Object,
      default: null,
    },
  },
  computed: {
    submerchantName() {
      if (!this.submerchant) {
        return null;
      }

      return this.submerchant.legalName || this.submerchant.name;
    },
    institution() {
      if (!this.submerchant) {
        return null;
      }

      return getFinancialInstitution(
        this.submerchant.financialInstitutionLicence
      );
    },
    licenceTypeWithArticle() {
      if (!this.institution) {
        return null;
      }

      return withIndefiniteArticle(this.institution.licenceType);
    },
  },
};
</script>
<style></style>
